import React from 'react'
import {Trans} from 'react-i18next'
import Typography from '@material-ui/core/Typography'
import {AlertDialog} from '../../../Common/Dialog'
import messages from '../../../../assets/messages'

type Props = {
  open: boolean
  onProceed: () => void
  onClose: () => void
}

/**
 * PT-5568 — shown when a client tries to deposit into a PAMM Investor account.
 * Explains that deposits go to the linked trading account and that funds must
 * then be transferred into the PAMM account. The CTA sends the client to the
 * deposit page to choose their trading account (the PAMM account is not
 * depositable, so it is filtered out of the selection).
 */
export const PammDepositRedirectModal: React.FC<Props> = ({open, onProceed, onClose}) => (
  <AlertDialog
    open={open}
    title={<Trans {...messages.pammDepositRedirectTitle} />}
    agreeText={<Trans {...messages.pammDepositRedirectCta} />}
    disagreeText={<Trans {...messages.cancel} />}
    onAgree={onProceed}
    onDisagree={onClose}
    onClose={onClose}
  >
    <Typography variant="body1" gutterBottom>
      <Trans {...messages.pammDepositRedirectLine1} />
    </Typography>
    <Typography variant="body1">
      <Trans {...messages.pammDepositRedirectLine2} />
    </Typography>
  </AlertDialog>
)
